import { GetterTree } from 'vuex';
import { State } from '@/manager/convocation/store/state';

import { Participant } from '@/manager/convocation/participant.model';
import { Convocation } from '@/manager/convocation/convocation.model';
import { Note } from '@/manager/convocation/note.model';
import { Log } from '@/manager/convocation/log.model';
import { PostponementLog } from '@/manager/convocation/postponementLog.model';

export interface Getters {
    getConvocationsList: Convocation[];
    getConvocation: Convocation;
    getConvocationNotes: Note[];
    getConvocationNote: Note;
    getParticipant: Participant;
    getParticipantNotes: Note[];
    getParticipantNote: Note;
    getParticipantLog: Log;
    getPostponementLog: PostponementLog;
    getParticipantListRequests: any[];
}

export const getters: GetterTree<State, any> = {
    getConvocationsList: (state) => state.list,
    getNextConvocationList: (state) => state.nextConvocationList,
    getTagList: (state) => state.tagList,
    getPaymentStatusList: (state) => state.paymentStatusList,
    getConvocation(state: State) {
        return (id: string) => {
            return state.list.find((convocation: any) => convocation.id === id);
        };
    },
    getConvocationNotes(state: State) {
        return state.convocationNoteList;
    },
    getConvocationNote(state: State) {
        return (noteId: string) => {
            return state.convocationNoteList.find((note: any) =>  note.id === noteId);
        };
    },
    getParticipantList: (state) => {
        return state.participantList;
    },
    getWaitingList: (state) => {
        return state.waitingList;
    },
    getCountWaitingList: (state) => {
        return state.countWaitingList;
    },
    getPostponeList: (state) => {
        return state.pendingPostpone;
    },
    getCountPostponeList: (state) => {
        return state.countPostponeList;
    },
    getRepeaterList: (state) => {
        return state.repeaterList;
    },
    getTeamList: (state) => {
        return state.teamList;
    },
    getStatesConvocation: (state) => {
        return state.convocationsStatesList;
    },
    getParticipant(state: State) {
        return (idParticipant: string) => {
            return state.participantList.find((participant: any) =>  participant.id === idParticipant);
        };
    },
    getWaitingParticipant(state: State) {
        return (idParticipant: string) => {
            return state.waitingList.find((participant: any) =>  participant.id === idParticipant);
        };
    },
    getPostponeParticipant(state: State) {
        return (idParticipant: string) => {
            return state.pendingPostpone.find((participant: any) =>  participant.id === idParticipant);
        };
    },
    getRepeaterParticipant(state: State) {
        return (idParticipant: string) => {
            return state.repeaterList.find((participant: any) =>  participant.id === idParticipant);
        };
    },
    getTeamParticipant(state: State) {
        return (idParticipant: string) => {
            return state.teamList.find((participant: any) =>  participant.id === idParticipant);
        };
    },
    getParticipantNotes(state: State) {
        return (participantId: string) => {
            return state.participantNoteList.filter((note: any) =>  note.participantId === participantId);
        };
    },
    getParticipantLog(state: State) {
        return (participantId: string) => {
            return state.participantLogList.find((log: any) =>  log.participantId === participantId);
        };
    },
    getParticipantPostponementLog(state: State) {
        return (participantId: string) => {
            return state.participantPostponementLogList.find((log: any) =>  log.participantId === participantId);
        };
    },
    getParticipantTraspasementLog(state: State) {
        return (participantId: string) => {
            return state.participantTraspasementLogList.find((log: any) =>  log.participantId === participantId);
        };
    },
    getParticipantNote(state: State) {
        return (noteId: string) => {
            return state.participantNoteList.find((note: any) =>  note.id === noteId);
        };
    },
    getParticipantListRequests: (state) => state.participantListRequests,
    getParticipantMassiveEmailList: (state) => state.participantMassiveEmailList,
};
